import React from 'react';
import { useNavigate } from 'react-router-dom';

function slugify(text) {
  return String(text).toLowerCase().replace(/\s+/g, '-').replace(/\//g, '').replace(/_/g, '-');
}

function normalizeEmploymentType(value) {
  return String(value).toLowerCase().replace(/_/g, '-');
}

function buildJobFilterPath(type, value) {
  const params = new URLSearchParams();

  switch (type) {
    case 'employment':
      params.set('employment_type', normalizeEmploymentType(value));
      break;
    case 'seniority':
      params.set('seniority_level', String(value).toLowerCase());
      break;
    case 'location':
      params.set('location_eligibility', value);
      break;
    case 'country':
      params.set('location_country', value);
      break;
    case 'category':
      params.set('category_id', String(value));
      break;
    default:
      break;
  }

  return `/jobs?${params.toString()}`;
}

function buildTestId(type, value, testIdValue) {
  if (testIdValue) return `rwm-job-tag-${type}-${testIdValue}`;

  switch (type) {
    case 'employment':
      return `rwm-job-tag-employment-${normalizeEmploymentType(value)}`;
    case 'seniority': {
      const first = String(value).split(',')[0].trim().toLowerCase();
      return `rwm-job-tag-seniority-${first}`;
    }
    case 'location':
      return `rwm-job-tag-location-${slugify(value)}`;
    case 'country':
      return `rwm-job-tag-country-${slugify(value)}`;
    case 'category':
      return `rwm-job-tag-category-${value}`;
    default:
      return `rwm-job-tag-${type}-${slugify(value)}`;
  }
}

export default function JobTag({ type, value, testIdValue, className, style, children }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    navigate(buildJobFilterPath(type, value));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleClick(e);
    }
  };

  return (
    <span
      role="button"
      tabIndex={0}
      className={`rwm-job-tag ${className || ''}`.trim()}
      style={style}
      data-testid={buildTestId(type, value, testIdValue)}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      {children}
    </span>
  );
}
